export const STORE = {
  profile: "ps",
  profile_version: import.meta.env.VITE_APP_VERSION,
  settings: "ss",
  settings_version: import.meta.env.VITE_APP_VERSION
};
